"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _FlamingoSwapSocketService_ws;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlamingoSwapSocketService = void 0;
const isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
const FlamingoSwapConstants_1 = require("../../../constants/FlamingoSwapConstants");
class FlamingoSwapSocketService {
    constructor() {
        _FlamingoSwapSocketService_ws.set(this, void 0);
    }
    onBlockAdded({ callback }) {
        __classPrivateFieldSet(this, _FlamingoSwapSocketService_ws, new isomorphic_ws_1.default(FlamingoSwapConstants_1.BLOCKCHAIN_WSS_URL), "f");
        __classPrivateFieldGet(this, _FlamingoSwapSocketService_ws, "f").onopen = () => {
            const block_added = {
                jsonrpc: '2.0',
                method: 'subscribe',
                params: ['block_added'],
                id: 1,
            };
            __classPrivateFieldGet(this, _FlamingoSwapSocketService_ws, "f").send(JSON.stringify(block_added));
        };
        __classPrivateFieldGet(this, _FlamingoSwapSocketService_ws, "f").onmessage = () => __awaiter(this, void 0, void 0, function* () {
            yield callback();
        });
    }
    closeConnection() {
        if (!__classPrivateFieldGet(this, _FlamingoSwapSocketService_ws, "f"))
            return;
        __classPrivateFieldGet(this, _FlamingoSwapSocketService_ws, "f").close();
        __classPrivateFieldSet(this, _FlamingoSwapSocketService_ws, null, "f");
    }
}
exports.FlamingoSwapSocketService = FlamingoSwapSocketService;
_FlamingoSwapSocketService_ws = new WeakMap();
